import axios from 'axios';
import { AxiosHttpPost } from 'axios-http';
import { COMPANY_MANAGER, USER_MANAGER } from 'resources/links';

export async function getReportUserManeger(name: string) {
    let data = {
        name
    };
    return AxiosHttpPost({
        url: USER_MANAGER.getReport,
        data
    });
}


export async function getReportCompany(ids: number[]) {
    return axios.post(COMPANY_MANAGER.getReportCompany, ids, {
        withCredentials: true,
        responseType: 'blob',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
    });
}

